import React from 'react';
import { BookOpen, Heart, Mail, Facebook, Twitter, Instagram } from 'lucide-react';

export const Footer = ({ activeTab, setActiveTab }) => {
  const currentYear = new Date().getFullYear();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-navyBlue text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo and Tagline */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img src={process.env.REACT_APP_LOGO_URL} alt="Doctrina Charter School" className="h-16 w-16" />
              <div>
                <h3 className="text-2xl font-bold">DOCTRINA</h3>
                <p className="text-sm text-tealAccent">Charter School</p>
              </div>
            </div>
            <p className="text-white/80 mb-4 max-w-md">
              Empowering educators, igniting futures. A transformative middle school where teachers lead, community drives learning, and every student thrives.
            </p>
            <p className="text-sm text-white/60 italic">"From Roots to Wings"</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => handleTabChange('mission')} className="text-white/80 hover:text-tealAccent transition-colors duration-200">Mission & Vision</button>
              </li>
              <li>
                <button onClick={() => handleTabChange('founder')} className="text-white/80 hover:text-tealAccent transition-colors duration-200">Founder's Message</button>
              </li>
              <li>
                <button onClick={() => handleTabChange('mascot')} className="text-white/80 hover:text-tealAccent transition-colors duration-200">Our Mascot</button>
              </li>
              <li>
                <button onClick={() => handleTabChange('plan')} className="text-white/80 hover:text-tealAccent transition-colors duration-200">10-Year Plan</button>
              </li>
              <li>
                <button onClick={() => handleTabChange('campus')} className="text-white/80 hover:text-tealAccent transition-colors duration-200">Campus Vision</button>
              </li>
              <li>
                <button onClick={() => handleTabChange('educators')} className="text-white/80 hover:text-tealAccent transition-colors duration-200">Educator-Led Model</button>
              </li>
              <li>
                <button onClick={() => handleTabChange('contact')} className="text-white/80 hover:text-tealAccent transition-colors duration-200">Contact Us</button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-2 text-white/80">
              <li className="flex items-start space-x-2">
                <Mail size={18} className="mt-1 flex-shrink-0" />
                <span>doctrinacharterschool@gmail.com</span>
              </li>
              <li>
                <p className="text-sm">Inland Empire, CA</p>
                <p className="text-sm">Serving Romoland, Homeland, Menifee, and Winchester</p>
              </li>
            </ul>

            {/* Social Media Placeholders */}
            <div className="mt-4">
              <h5 className="font-semibold text-sm mb-2">Follow Us</h5>
              <div className="flex space-x-3">
                <a href="#" className="bg-white/10 hover:bg-tealAccent/20 p-2 rounded-lg transition-colors duration-200">
                  <Facebook size={20} />
                </a>
                <a href="#" className="bg-white/10 hover:bg-tealAccent/20 p-2 rounded-lg transition-colors duration-200">
                  <Twitter size={20} />
                </a>
                <a href="#" className="bg-white/10 hover:bg-tealAccent/20 p-2 rounded-lg transition-colors duration-200">
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              &copy; {currentYear} Doctrina Charter School. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-white/60">
              <a href="#" className="hover:text-tealAccent transition-colors duration-200">Privacy Policy</a>
              <a href="#" className="hover:text-tealAccent transition-colors duration-200">Terms of Service</a>
              <a href="#" className="hover:text-tealAccent transition-colors duration-200">Accessibility</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;